export default __webpack_public_path__ + "static/media/redness.cc811427.svg";